import { render, staticRenderFns } from "./newCaixa.vue?vue&type=template&id=8f9ab9ba&scoped=true&"
import script from "./newCaixa.vue?vue&type=script&lang=js&"
export * from "./newCaixa.vue?vue&type=script&lang=js&"
import style0 from "./newCaixa.vue?vue&type=style&index=0&id=8f9ab9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9ab9ba",
  null
  
)

export default component.exports